export const API_PATH = {
  ROLE_LIST: getV1Path("role/list"),
  USER_INFO: getV1Path("user"),
  LOGIN: getVersionPath("user/login", "v1"),
  CHANGE_PASS: getCasV1Path("user/repass"),
  NOTI_LIST: getVersionPath("notification/overview", "v1"),
  SIGNUP: getCasV1Path("user/signup"),
};

export const GENERAL = {
  GENERAL_DATA: getV1Path("report/revenue/trending"),
  TRANSACTION_REPORT: getShubV1Path("transaction/retrieve-report"),
  TRANSACTION_DETAIL_REPORT: getShubV1Path(
    "transaction/retrieve-detail-report"
  ),
  PARTNER_TRANSACTION_REPORT: getShubV1Path(
    "transaction/retrieve-partner-report"
  ),
  PARTNER_TRANSACTION_DETAIL_REPORT: getShubV1Path(
    "transaction/retrieve-partner-detail-report"
  ),
};

export const ERROR_CODE_GENERAL = {
  GENERAL: getV1Path("report/error-code/trending"),
  ERROR_CODE: getShubV1Path("transaction/retrieve-error-report"),
  DETAIL_ERROR_CODE: getShubV1Path("transaction/retrieve-detail-error-report"),
};

export const ERROR_CODE_MANAGEMENT = {
  LIST: getV1Path("errorcode/management/list-error-code"),
  DETAIL: getV1Path("errorcode/management/detail-error-code"),
  UPDATE: getV1Path("errorcode/management/edit-error-code"),
  CREATE: getV1Path("errorcode/management/add-error-code"),
  DELETE: getV1Path("errorcode/management/remove-error-code"),
};

export const FILTER = {
  OVERVIEW_SERVICE: getShubV1Path("filter/overview-service"),
};

export const STORE_API = {
  LIST: getChubVersionPath("store/list", "v1"),
  DETAIL: getChubVersionPath("store/detail", "v1"),
  CREATE: getChubVersionPath("store/create-store", "v1"),
  UPDATE: getChubVersionPath("store/update", "v1"),
  DELETE: getChubVersionPath("store/delete", "v1"),
};

export const USER_MANAGEMENT_V2 = {
  USER_LIST: getVersionPath("user/list", "v2"),
  USER_LIST_V1: getVersionPath("user/list", "v1"),
  USER_LIST_V3: getVersionPath("user/list", "v3"),
  UPDATE_STATUS: getVersionPath("user/update-status", "v1"),
  FILTER_LIST: getCasV1Path("user/management/filter/overview-for-filter"),
};

export const PATH_CONFIG = {
  LIST: getV1Path("config"),
  CREATE_CONFIG: getV1Path("config/create"),
  UPDATE_CONFIG: getV1Path("config/update"),
  DELETE_CONFIG: getV1Path("config/delete"),
  CONFIG_DETAIL: getV1Path("config/detail"),
};

export const CONTENT_MANAGEMENT = {
  LIST: getV1Path("content/list-content-cms"),
  CREATE_CONTENT: getV1Path("content/create-content"),
  UPDATE_CONTENT: getV1Path("content/update-content"),
  DELETE_CONTENT: getV1Path("content/delete-content"),
};

export const COUNTRY_MANAGEMENT = {
  LIST: getChubVersionPath("country/list-country", "v1"),
  CREATE_COUNTRY: getChubVersionPath("country/create-country", "v1"),
  UPDATE_COUNTRY: getChubVersionPath("country/update-country", "v1"),
  DETAIL: getChubVersionPath("country/detail-country", "v1"),
  DELETE: getChubVersionPath("country/delete-country", "v1"),
};

export const ROAMING_MANAGEMENT = {
  LIST: getV1Path("mobiledata/list-mobiledata"),
  DETAIL: getV1Path("mobileData/detail"),
  CREATE: getV1Path("mobileData/create"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData/update"),
  PARTNER_LIST_ROAMING: getV1Path("roaming/partner/list-roaming-partner"),
};

export const TOPUP_MANAGEMENT = {
  LIST: getChubVersionPath("mobiledata/list-mobiledata", "v1"),
  DETAIL: getChubVersionPath("mobileData", "v1"),
  CREATE: getChubVersionPath("mobiledata/create", "v1"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData"),
  LIST_B2B: getV1Path("mobileData/listSyncMobileData"),
  IMPORT_FROM_B2B: getV1Path("mobileData/importArray"),
  CREATEV2: getVersionPath("mobileData/create", "v2"),
  UPDATEV2: getVersionPath("mobileData", "v2"),
  ADD_SUPPLIER: getVersionPath("mobileData/supplier", "v1"),
  ADD_CATEGORY: getVersionPath("mobileData/category", "v1"),
};

export const B2B_PACKAGE_MANAGEMENT = {
  B2B_PARTNER_LIST: getChubVersionPath("btob/merchant/list", "v1"),
  DETAIL_DATA_PACKAGES: getChubVersionPath("btob/mobiledata/detail", "v1"),
  UPDATE_DATA_PACKAGES: getChubVersionPath("btob/mobiledata/update", "v1"),
  CREATE_DATA_PACKAGES: getChubVersionPath("btob/mobiledata/create", "v1"),
  GET_DATA_PACKAGES_LIST: getChubVersionPath("btob/mobiledata/list", "v1"),
  GET_TRANSACTION: getChubVersionPath("mobile/data/transactions", "v2"),
  DELETE_DATA_PACKAGES: getChubVersionPath("mobile/data/packages", "v2"),
  GET_DATA_GROUP: getChubVersionPath("btob/mobiledata/group/list", "v1"),
  SET_TOP_PRIORITY: getChubVersionPath(
    "btob/mobiledata/suppliers/set-top-priority",
    "v2"
  ),
  EXPORT_TRANSACTION: getChubVersionPath(
    "mobile/data/transaction/export",
    "v1"
  ),
  EXPORT_DATA_CODE_REPORT: getChubVersionPath(
    "mobile/data/transaction/export-statistic",
    "v1"
  ),
  SEARCH_INVENTORY: getChubVersionPath("btob/inventory/list", "v1"),
  IMPORT_INVENTORY_FROM_EXCEL: getChubVersionPath(
    "btob/inventory/import",
    "v1"
  ),
};

export const FILE_MANAGEMENT = {
  LIST: getChubVersionPath("file/list-file", "v1"),
  UPLOAD_FILE: getChubVersionPath("file/upload-file", "v1"),
  REPLACE_FILE: getChubVersionPath("file/replace-file", "v1"),
  DELETE_FILE: getChubVersionPath("file/delete-file", "v1"),
};

export const ADDRESS_PATH = {
  PROVINCE_LIST: getChubVersionPath("address/list-provinces", "v1"),
  PROVINCE_DETAIL: getChubVersionPath("address/detail-provinces", "v1"),
  UPDATE_PROVINCE: getChubVersionPath("address/update-provinces", "v1"),
  CREATE_PROVINCE: getChubVersionPath("address/create-provinces", "v1"),
  DELETE_PROVINCE: getChubVersionPath("address/delete-provinces", "v1"),
  DISTRICT_LIST: getChubVersionPath("address/list-districts", "v1"),
  DISTRICT_DETAIL: getChubVersionPath("address/detail-districts", "v1"),
  UPDATE_DISTRICT: getChubVersionPath("address/update-districts", "v1"),
  CREATE_DISTRICT: getChubVersionPath("address/create-districts", "v1"),
  DELETE_DISTRICT: getChubVersionPath("address/delete-districts", "v1"),
  WARD_LIST: getChubVersionPath("address/list-wards", "v1"),
  WARD_DETAIL: getChubVersionPath("address/detail-wards", "v1"),
  UPDATE_WARD: getChubVersionPath("address/update-wards", "v1"),
  CREATE_WARD: getChubVersionPath("address/create-wards", "v1"),
  DELETE_WARD: getChubVersionPath("address/delete-wards", "v1"),
  REGIONS: getChubVersionPath("address/list-administrative-regions", "v1"),
  UNITS: getChubVersionPath("address/list-administrative-units", "v1"),
};

export const PROVINCE_CONFIGURATION = {
  LIST: getChubVersionPath("address/list-provinces", "v1"),
  DETAIL: getChubVersionPath("address/detail-provinces", "v1"),
  CREATE: getChubVersionPath("address/create-provinces", "v1"),
  UPDATE: getChubVersionPath("address/update-provinces", "v1"),
  DELETE: getChubVersionPath("address/delete-provinces", "v1"),
};

export const WARD_CONFIGURATION = {
  LIST: getChubVersionPath("address/list-wards", "v1"),
  DETAIL: getChubVersionPath("address/detail-wards", "v1"),
  CREATE: getChubVersionPath("address/create-wards", "v1"),
  UPDATE: getChubVersionPath("address/update-wards", "v1"),
  DELETE: getChubVersionPath("address/delete-wards", "v1"),
};

export const DISTRICT_CONFIGURATION = {
  LIST: getChubVersionPath("address/list-districts", "v1"),
  DETAIL: getChubVersionPath("address/detail-districts", "v1"),
  CREATE: getChubVersionPath("address/create-districts", "v1"),
  UPDATE: getChubVersionPath("address/update-districts", "v1"),
  DELETE: getChubVersionPath("address/delete-districts", "v1"),
};

export const COUNTRY_CONFIGURATION = {
  LIST: getChubVersionPath("country/list-country", "v1"),
  DETAIL: getChubVersionPath("country/detail-country", "v1"),
  CREATE: getChubVersionPath("country/create-country", "v1"),
  UPDATE: getChubVersionPath("country/update-country", "v1"),
  DELETE: getChubVersionPath("country/delete-country", "v1"),
};

export const CDN_CONFIGURATION = {
  LIST: getChubVersionPath("file/list-file", "v1"),
  UPLOAD: getChubVersionPath("file/upload-file", "v1"),
  DELETE: getChubVersionPath("file/delete-file", "v1"),
};

export const MANAGE_CONFIG = {
  LIST: getChubVersionPath("config", "v1"),
  DETAIL: getChubVersionPath("config/detail", "v1"),
  CREATE: getChubVersionPath("config/create", "v1"),
  UPDATE: getChubVersionPath("config/update", "v1"),
  DELETE: getChubVersionPath("config/delete", "v1"),
};

export const PACKAGES_REGISTRAION = {
  PACKAGES_BY_PHONE: getVersionPath("mobile/data/phone", "v3"),
  DEFAULT_PACKAGE: getV1Path("mobile/data/packages"),
  REGISTER: getV1Path("mobile/data/transaction/topup"),
};

export const FEATURE_MANAGEMENT = {
  LIST: getCasV1Path("feature/overview"),
  UPDATE: getCasV1Path("feature/edit"),
  CREATE: getCasV1Path("feature/add"),
  DETAIL: getCasV1Path("feature/view"),
  DELETE: getCasV1Path("feature/erase"),
  USER_FEATURE: getCasV1Path("userpermission/overview"),
  FILTER_LIST: getCasV1Path("feature/overview-for-filter"),
};

export const PARTNER_MANAGEMENT = {
  LIST: getChubVersionPath("partner/list", "v3"),
  DETAIL: getChubVersionPath("partner/detail", "v3"),
  UPDATE: getChubVersionPath("partner/update", "v3"),
  CREATE: getChubVersionPath("partner/create", "v3"),
  DELETE: getChubVersionPath("partner/delete", "v3"),
  PARTNER_FOR_FILTER: getChubVersionPath("partner/list-for-filter", "v1"),
};

export const BALANCE_TICKET = {
  LIST: getChubVersionPath("ticket/list", "v1"),
  DETAIL: getChubVersionPath("ticket/detail", "v1"),
  UPDATE: getChubVersionPath("ticket/update", "v1"),
  CREATE: getChubVersionPath("ticket/create", "v1"),
  TRANSLISTFORREFUND: getChubVersionPath("ticket/list/transaction", "v1"),
};

export const ROAMING_PARTNER = {
  LIST: getVersionPath("roaming/partner/list-roaming-partner", "v1"),
  DETAIL: getVersionPath("roaming/partner/detail-roaming-partner", "v1"),
  UPDATE: getVersionPath("roaming/partner/update-roaming-partner", "v1"),
  CREATE: getVersionPath("roaming/partner/create-roaming-partner", "v1"),
  DELETE: getVersionPath("roaming/partner/delete-roaming-partner", "v1"),
};

export const SERVICE_MANAGEMENT = {
  LIST: getVersionPath("service/list", "v1"),
  DETAIL: getVersionPath("service/detail", "v1"),
  CREATE: getVersionPath("service/create", "v1"),
  UPDATE: getVersionPath("service/update", "v1"),
  DELETE: getVersionPath("service/delete", "v1"),
  GROUP: getVersionPath("group/list", "v1"),
};

export const CATEGORY_MANAGEMENT = {
  LIST: getChubVersionPath("category/list-category", "v1"),
  DETAIL: getChubVersionPath("category/detail-category", "v1"),
  CREATE: getChubVersionPath("category/create-category", "v1"),
  UPDATE: getChubVersionPath("category/update-category", "v1"),
  DELETE: getChubVersionPath("category/delete-category", "v1"),
  LIST_V2: getChubVersionPath("category/list-category", "v2"),
  FILTER_LIST: getChubVersionPath("filter/overview-categories", "v2"),
};

export const TRAVEL_SIM = {
  LIST: getV1Path("profile/list"),
  DETAIL: getV1Path("profile/find"),
};

export const TRAVEL_SIM_PROFILE = {
  LIST: getVersionPath("profile/list-profile-transaction", "v1"),
  DETAIL: getVersionPath("profile/detail-profile-transaction", "v1"),
  APPROVE: getVersionPath("infomation/connection/approve", "v1"),
};

export const APP_PROFILE_REGISTER = {
  LIST: getChubVersionPath("contract/list", "v1"),
  DETAIL: getChubVersionPath("contract/", "v1"),
  VERIFY: getChubVersionPath("contract/verified", "v2"),
  SYNC_STATUS: (id: string) =>
    getChubVersionPath(`contract/${id}/sync-status`, "v3"),
  SYNC_ALL_STATUS: getChubVersionPath("contract/sync-all-status", "v1"),
  EXPORT_EXCEL: getChubVersionPath("contract/export-excel", "v1"),
  DOWNLOAD_ZIP: getChubVersionPath("contract/download-contract/", "v1"),
};

export const APP_TRANSACTION = {
  LIST: getVersionPath("transaction/list-transaction", "v1"),
  DETAIL: getVersionPath("transaction/detail-transaction", "v1"),
  CHECK_STATUS: getVersionPath("transaction/check-transaction", "v1"),
};

export const TRANSACTION_HISTORY = {
  MOBISIMLIST: getChubVersionPath("transaction/list-transaction", "v1"),
  NICESIMLIST: getChubVersionPath("transaction/list-transaction", "v1"),
  PACKAGELIST: getChubVersionPath("transaction/list-transaction", "v1"),
  INBOUNDLIST: getChubVersionPath("transaction/list-transaction", "v1"),
  OUTBOUNDLIST: getChubVersionPath("transaction/list-transaction", "v1"),
  CASHFLOWLIST: getChubVersionPath("transaction/overview-cash-flow", "v2"),
  AIRTIMELIST: getChubVersionPath("transaction/list-transaction", "v1"),
  BALANCELIST: getChubVersionPath("transaction/list-transaction", "v1"),
  TRANS_DETAIL: getChubVersionPath("transaction/detail-transaction", "v1"),
  PRIVATE_LIST: getChubVersionPath(
    "transaction/list-transaction-private",
    "v1"
  ),
  PRIVATE_TRANS_DETAIL: getChubVersionPath(
    "transaction/detail-transaction-private",
    "v1"
  ),
};

export const APP_FEEDBACK = {
  LIST: getChubVersionPath("feedback", "v1"),
  DETAIL: getChubVersionPath("feedback", "v1"),
};

export const PAYMENT_METHOD = {
  LIST: getVersionPath("payment/methods/management/list-payment-methods", "v1"),
  DETAIL: getVersionPath(
    "payment/methods/management/detail-payment-methods",
    "v1"
  ),
  CREATE: getVersionPath(
    "payment/methods/management/create-payment-methods",
    "v1"
  ),
  UPDATE: getVersionPath(
    "payment/methods/management/update-payment-methods",
    "v1"
  ),
  DELETE: getVersionPath(
    "payment/methods/management/delete-payment-methods",
    "v1"
  ),
};

export const SUPPLIER_MANAGEMENT = {
  B2B_SUPPLIER_LIST: getChubVersionPath("btob/supplier/list", "v1"),
  LIST: getVersionPath("suppliers/management/list-supplier", "v1"),
  DETAIL: getVersionPath("suppliers/management/detail-supplier", "v1"),
  CREATE: getVersionPath("suppliers/management/create-supplier", "v1"),
  UPDATE: getVersionPath("suppliers/management/update-supplier", "v1"),
  DELETE: getVersionPath("suppliers/management/delete-supplier", "v1"),
};

export const AIRTIME_MANAGEMENT = {
  LIST: getChubVersionPath("airtime/list", "v1"),
  DETAIL: getChubVersionPath("airtime/detail", "v1"),
  CREATE: getChubVersionPath("airtime/create", "v1"),
  UPDATE: getChubVersionPath("airtime/update", "v1"),
  DELETE: getChubVersionPath("airtime/delete", "v1"),
};

export const DISCOUNT_MANAGEMENT = {
  LIST: getChubVersionPath("commission/list", "v1"),
  DETAIL: getChubVersionPath("commission/detail", "v1"),
  CREATE: getChubVersionPath("commission/create", "v1"),
  UPDATE: getChubVersionPath("commission/update", "v1"),
  GROUP_LIST: getChubVersionPath("group/list", "v1"),
  PRODUCT_LIST: getChubVersionPath("product/listProduct", "v1"),
  USER_LIST: getChubVersionPath("user/list", "v3"),
};

export const PRODUCT_MANAGEMENT = {
  LIST: getVersionPath("product/listProduct", "v1"),
};

export const CARRIER_MANAGEMENT = {
  LIST: getVersionPath("carrier/list", "v1"),
};

export const RESET_OTP = {
  RESET: getVersionPath("user/reset-otp", "v1"),
};

export const INDIVIDUAL_USER_APP_MANAGEMENT = {
  LIST: getChubVersionPath("user/list", "v3"),
  DETAIL: getChubVersionPath("user/info", "v1"),
  RESET_OTP: getChubVersionPath("user/reset-otp", "v1"),
};

export const BUSINESS_USER_APP_MANAGEMENT = {
  LIST: getChubVersionPath("user/list", "v3"),
  DETAIL: getChubVersionPath("user/info", "v1"),
  RESET_OTP: getChubVersionPath("user/reset-otp", "v1"),
};

export const SIM_MANAGEMENT = {
  LIST: getVersionPath("sim/list", "v1"),
  DETAIL: getVersionPath("sim/detail", "v1"),
  IMPORT_TABLE_TEMPLATE: getVersionPath("template/import/sim/config", "v1"),
  IMPORT_SIM: getVersionPath("import/sim", "v1"),
  IMPORT_FILE_TEMPLATE: getVersionPath("template/import/sim", "v1"),
};

export const SUPPORT_FEATURE = {
  VIEW_PLAN: getChubVersionPath("support/view-plan", "v1"),
  VIEW_SIM: getChubVersionPath("support/view-sim", "v1"),
  API_DOCUMENT: getCasV1Path("support/overview-api-document"),
  OFFICIAL_DISPATCH: getCasV1Path("support/overview-notice"),
};

export const FILTER_FEATURE = {
  SERVICE_LIST: getShubV1Path("service/list"),
  CARRIER_LIST: getChubVersionPath("filter/overview-carrier", "v2"),
  PACKAGE_LIST: getChubVersionPath("filter/overview-package", "v2"),
  NATION_LIST: getVersionPath("filter/overview-nation", "v1"),
  NUMER_TYPE_LIST: getChubVersionPath("filter/overview-categories", "v1"),
  SUPPLIER_LIST: getVersionPath("suppliers/management/list-supplier", "v1"),
  PARTNER_LIST: getChubVersionPath("partner/list", "v3"),
  STORE_LIST: getChubVersionPath("store/list", "v1"),
  STAFF_LIST: getChubVersionPath(
    "filter/overview-users-by-provider-mobitopup",
    "v2"
  ),
  USER_LIST_B2B: getChubVersionPath(
    "filter/overview-users-by-provider-b2b",
    "v2"
  ),
  DESTINY_LIST: getChubVersionPath("filter/overview-categories", "v1"),
  NUMEROLOGY_LIST: getChubVersionPath("filter/overview-categories", "v1"),
  ZODIAC_LIST: getChubVersionPath("filter/overview-categories", "v1"),
  DENOMINATION_LIST: getChubVersionPath("filter/overview-airtime", "v1"),
};

export const B2B_ACCOUNT = {
  LIST: getVersionPath("b2b-account/list", "v1"),
  DETAIL: getVersionPath("b2b-account/detail", "v1"),
  CREATE: getVersionPath("b2b-account/create", "v1"),
  UPDATE: getVersionPath("b2b-account/update", "v1"),
  DELETE: getVersionPath("b2b-account/delete", "v1"),
  RESET_PASSWORD: getVersionPath("b2b-account/reset-password", "v1"),
};

export const B2B_PARTNER = {
  LIST: getVersionPath("b2b-partner/list", "v1"),
  DETAIL: getVersionPath("b2b-partner/detail", "v1"),
  CREATE: getVersionPath("b2b-partner/create", "v1"),
  UPDATE: getVersionPath("b2b-partner/update", "v1"),
  DELETE: getVersionPath("b2b-partner/delete", "v1"),
};

export const ROLE_MANAGEMENT_V1 = {
  FILTER: getV1Path("role/list"),
  LIST: getV1Path("role/management/overview"),
  VIEW: getV1Path("role/management/view"),
};

export const SYSTEM_USER_MANAGEMENT = {
  LIST: getVersionPath("user/list", "v1"),
  DETAIL: getV1Path("user"),
  UPDATE: getV1Path("user/update-user"),
  CREATE: getV1Path("user/create-user"),
  DELETE: getV1Path("user/delete-user"),
  FILTER: getV1Path("user/list"),
  SIGN_UP: getV1Path("user/signup"),
};

export const USER_STORE = {
  LIST: getChubVersionPath("user/list", "v3"),
  DETAIL: getChubVersionPath("user/info", "v1"),
  CREATE: getChubVersionPath("user/create", "v3"),
  UPDATE: getChubVersionPath("user/update", "v3"),
  DELETE: getChubVersionPath("user/delete", "v3"),
};

export const USER_STAFF = {
  LIST: getChubVersionPath("user/list", "v3"),
  DETAIL: getChubVersionPath("user/info", "v1"),
  CREATE: getChubVersionPath("user/create", "v3"),
  UPDATE: getChubVersionPath("user/update", "v3"),
  DELETE: getChubVersionPath("user/delete", "v3"),
};

export const USER_CHAIN = {
  LIST: getChubVersionPath("user/list", "v3"),
  DETAIL: getChubVersionPath("user/info", "v1"),
  CREATE: getChubVersionPath("user/create", "v3"),
  UPDATE: getChubVersionPath("user/update", "v3"),
  DELETE: getChubVersionPath("user/delete", "v3"),
};

export const PERMISSION_DATA = {
  LIST: getCasV1Path("menu/overview"),
  DETAIL: getCasV1Path("menu/view"),
  CREATE: getCasV1Path("menu/add"),
  UPDATE: getCasV1Path("menu/edit"),
  DELETE: getCasV1Path("menu/erase"),
  FILTER_LIST: getCasV1Path("menu/overview-for-filter"),
  USER_LIST: getVersionPath("user/list", "v3"),
  USER_MENU: getCasV1Path("usermenu/overview"),
};

export const CAPABILITY_MANAGEMENT = {
  LIST: getCasV1Path("capability/overview"),
  DETAIL: getCasV1Path("capability/view"),
  CREATE: getCasV1Path("capability/add"),
  UPDATE: getCasV1Path("capability/edit"),
  DELETE: getCasV1Path("capability/erase"),
  FILTER_LIST: getCasV1Path("capability/overview-for-filter"),
};

export const ROLE_MANAGEMENT = {
  LIST: getVersionPath("role/list", "v1"),
  DETAIL: getCasV1Path("role/view"),
  CREATE: getVersionPath("role/create", "v2"),
  UPDATE: getVersionPath("role/update", "v1"),
  DELETE: getVersionPath("role/delete", "v1"),
  FILTER_LIST: getVersionPath("role/list", "v1"),
};

export const IOT_SIM_LIST_LOOKUP = {
  LIST: getChubVersionPath(
    "repository/sim/data/overview-multiple-tracking",
    "v1"
  ),
  EXPORT_EXCEL: getChubVersionPath(
    "repository/sim/data/multiple-tracking",
    "v1"
  ),
  DOWNLOAD_TEMPLATE: getChubVersionPath(
    "repository/sim/data/template-multiple-tracking",
    "v1"
  ),
  SINGLE_TRACKING: getChubVersionPath(
    "repository/sim/data/single-tracking",
    "v1"
  ),
  ALERT_SUPPORT: getChubVersionPath(
    "repository/sim/data/warning-tracking",
    "v1"
  ),
};

export const PROVIDER_MANAGEMENT = {
  LIST: getCasV1Path("provider/management/overview"),
  DETAIL: getCasV1Path("provider/management/view"),
  CREATE: getCasV1Path("provider/management/add"),
  UPDATE: getCasV1Path("provider/management/edit"),
  DELETE: getCasV1Path("provider/management/erase"),
  FILTER_LIST: getCasV1Path("provider/management/filter/overview-for-filter"),
};

export const ACTION_LOG_MANAGEMENT = {
  LIST: getCasV1Path("actionlog/management/overview"),
  DETAIL: getCasV1Path("actionlog/management/view"),
  UPDATE: getCasV1Path("actionlog/management/system-edit"),
};

function getV1Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v1/${path}`;
}

function getVersionPath(path: String, version: string) {
  return `${process.env.REACT_APP_BASE_URL}/api/${version}/${path}`;
}

function getCasV1Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v1/${path}`;
}

function getShubV1Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v1/${path}`;
}

function getChubVersionPath(path: String, version: string) {
  return `${process.env.REACT_APP_BASE_URL}/api/${version}/${path}`;
}
